// src/mechanism/storage.js

import { Preferences } from '@capacitor/preferences';

const isHarmony = window.__IS_HARMONY__ === true;

// 1. 全局白名单：加入时间戳字段，确保与 user_info 作用域绝对一致
const GLOBAL_KEYS = [
    'access_token',
    'login_method',
    'user_info',
    'user_info_timestamp',
    'current_user_id',
    'has_agreed_privacy',

    'device_push_data',          // 设备 Token 及绑定状态
    'push_last_prompt_time',     // 7天弹窗冷却时间（设备级别）
    'push_has_prompted_first'    // 是否首次引导过（设备级别）
];

let cachedUserId = undefined;

/**
 * 核心拦截与校验机制 (异步方法)
 */
async function getRealKey(key) {
    if (GLOBAL_KEYS.includes(key)) {
        return key;
    }

    if (cachedUserId === undefined) {
        if (isHarmony) {
            cachedUserId = localStorage.getItem('current_user_id') || null;
        } else {
            const res = await Preferences.get({ key: 'current_user_id' });
            cachedUserId = res.value || null;
        }

        if (cachedUserId === 'null' || cachedUserId === '"null"') {
            cachedUserId = null;
        }
    }

    if (!cachedUserId) {
        return `${key}_guest`;
    }

    return `${key}_${cachedUserId}`;
}

export const Storage = {
    async setUserId(id) {
        cachedUserId = id ? String(id) : null;

        if (!id) {
            cachedUserId = null;

            if (isHarmony) {
                localStorage.removeItem('current_user_id');
            } else {
                await Preferences.remove({ key: 'current_user_id' });
            }
        } else {
            const stringifiedId = String(id);
            if (isHarmony) {
                localStorage.setItem('current_user_id', stringifiedId);
            } else {
                await Preferences.set({ key: 'current_user_id', value: stringifiedId });
            }
        }
    },

    async set(key, value) {
        if (value === null || value === undefined) {
            return this.remove(key);
        }

        const realKey = await getRealKey(key);
        const stringified = JSON.stringify(value);

        if (isHarmony) {
            localStorage.setItem(realKey, stringified);
            return;
        }
        await Preferences.set({ key: realKey, value: stringified });
    },

    async get(key) {
        const realKey = await getRealKey(key);
        let value = null;

        if (isHarmony) {
            value = localStorage.getItem(realKey);
        } else {
            const res = await Preferences.get({ key: realKey });
            value = res.value;
        }

        try {
            if (value === null) return null;
            return JSON.parse(value);
        } catch (e) {
            console.error(`[Storage] JSON 解析 Key: ${realKey} 失败`, e);
            return null;
        }
    },

    async removeRaw(rawKey) {
        if (isHarmony) {
            localStorage.removeItem(rawKey);
            return;
        }
        await Preferences.remove({ key: rawKey });
    },

    async remove(key) {
        const realKey = await getRealKey(key);
        if (isHarmony) {
            localStorage.removeItem(realKey);
            return;
        }
        await Preferences.remove({ key: realKey });
    },

    async clear() {
        if (isHarmony) {
            localStorage.clear();
            return;
        }
        await Preferences.clear();
    },

    async keys() {
        if (isHarmony) {
            return Object.keys(localStorage);
        }
        const { keys } = await Preferences.keys();
        return keys;
    }
};